import React from 'react';

const STOPS = [1, 2, 3, 4, 5];

export default function DialScale({ dial, value, onPick }) {
  const picked = Number(value);
  return (
    <fieldset className="sr-dial">
      <legend>{dial.label}</legend>
      <p className="sr-dial__description">{dial.description || ''}</p>
      <div className="sr-stops">
        <span className="sr-dial__end">
          <span className="sr-dial__word">{dial.low}</span>
        </span>
        {STOPS.map((stop) => {
          const selected = picked === stop;
          return (
            <button
              key={stop}
              type="button"
              aria-pressed={selected}
              aria-label={`${dial.label} ${stop}`}
              className={selected ? 'sr-stop sr-stop--on' : 'sr-stop'}
              onClick={() => onPick(dial.key, stop)}
            >
              {stop}
            </button>
          );
        })}
        <span className="sr-dial__end">
          <span className="sr-dial__word">{dial.high}</span>
        </span>
      </div>
      <div className="sr-dial__examples">
        <p className="sr-dial__example sr-dial__example--low">{dial.lowExample || ''}</p>
        <p className="sr-dial__example sr-dial__example--high">{dial.highExample || ''}</p>
      </div>
    </fieldset>
  );
}
